import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { trackFilterVisit } from '../../utils/analytics';

function ShowFilterCard(props) {

    //populating the degree dropdown and datalist on component mount
    const [degreeDropdownList, setDegreeDropdownList] = useState([]);
    const [degreeLoaded, setDegreeLoaded] = useState(false);
    //var degreeDropdownList = []

    function removeDuplicatesAndUndefined(array) {
        // Filter out undefined values
        const filteredArray = array.filter((item) => item !== undefined);
        // Remove duplicate items
        const uniqueArray = [...new Set(filteredArray)];
        return uniqueArray;

    }
    useEffect(() => {
        async function callDEgreeList() {
            await fetch(process.env.REACT_APP_FETCH_DEGREES)
                .then(response => response.json())
                .then(responseData => {
                    //setData(responseData);
                    //console.log('response data==='+responseData);
                    // Update the degreeDropdownList

                    responseData.forEach((item, index) => {
                        degreeDropdownList.push(item["degree_code"]);
                    });
                    //console.log("degreelist in fetch==="+degreeDropdownList);

                    setDegreeDropdownList(removeDuplicatesAndUndefined(degreeDropdownList));
                })
                .catch(error => {/* console.log(error) */});
        }
        callDEgreeList();
    }, [degreeDropdownList]);

    //Handling conditions to make sure required fields are submitted before making api calls.
    const [degreeSelected, setDegreeSelected] = useState(false);
    // COMMENTED OUT - Job Type Filter (may be reused later)
    // const [jopTypeSelected, setJobTypeSelected] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    //Flags for state management.
    const [showProgress, setShowProgress] = useState(false);
    
    // Search state
    const [searchTerm, setSearchTerm] = useState('');
    const [searchTimeout, setSearchTimeout] = useState(null);

    // Cleanup search timeout on unmount
    useEffect(() => {
        // console.log('[SEARCH-FRONTEND] Checkpoint: Component mounted, checking environment variables');
        // console.log('[SEARCH-FRONTEND] Checkpoint: REACT_APP_SEARCH_JOBS:', process.env.REACT_APP_SEARCH_JOBS || 'http://localhost:3000/search_jobs (fallback)');
        // console.log('[SEARCH-FRONTEND] Checkpoint: REACT_APP_GET_FILTERED_JOBS:', process.env.REACT_APP_GET_FILTERED_JOBS);
        // console.log('[SEARCH-FRONTEND] Checkpoint: REACT_APP_FETCH_DEGREES:', process.env.REACT_APP_FETCH_DEGREES);
        
        return () => {
            if (searchTimeout) {
                // console.log('[SEARCH-FRONTEND] Checkpoint: Component unmounting, clearing timeout');
                clearTimeout(searchTimeout);
            }
        };
    }, [searchTimeout]);
    
    const [formData, setFormData] = useState({
        // COMMENTED OUT - Job Type Filter (may be reused later)
        // job_type: '',
        degree: '',
    });

    const handleDegreeChange = (event, value) => {
        // console.log('Degree selected:', value);
        setFormData({ ...formData, "degree": value });
        setDegreeSelected(value !== null && value !== '');
        
        // Auto-update job table when degree is selected
        if (value !== null && value !== '') {
            // Track filter visit when degree is selected
            trackFilterVisit();
            // console.log('Auto-filtering jobs for degree:', value);
            props.changeLoadingState(true);
            props.showTable(true);
            
            axios.post(process.env.REACT_APP_GET_FILTERED_JOBS || 'http://localhost:3000/get_filtered_jobs', { degree: value })
                .then(response => {
                    // console.log('Filtered jobs response:', response.data);
                    props.updateFilteredJobs(response.data);
                    props.changeLoadingState(false);
                })
                .catch(error => {
                    // console.log('Filter error:', error);
                    props.changeLoadingState(false);
                });
        } else {
            // Clear results if no degree selected
            props.showTable(false);
        }
    }

    const handleSearchChange = (event) => {
        const value = event.target.value;
        // console.log('[SEARCH-FRONTEND] Checkpoint: Search input changed, value:', value);
        setSearchTerm(value);
        
        // Clear existing timeout
        if (searchTimeout) {
            // console.log('[SEARCH-FRONTEND] Checkpoint: Clearing existing timeout');
            clearTimeout(searchTimeout);
        }
        
        // Set new timeout for 1 second
        const newTimeout = setTimeout(() => {
            // console.log('[SEARCH-FRONTEND] Checkpoint: Timeout triggered, calling performSearch');
            performSearch(value);
        }, 1000);
        
        // console.log('[SEARCH-FRONTEND] Checkpoint: New timeout set for 1 second');
        setSearchTimeout(newTimeout);
    };

    const performSearch = (term) => {
        // console.log('[SEARCH-FRONTEND] Checkpoint: performSearch called with term:', term);
        
        if (!term || term.trim().length === 0) {
            // console.log('[SEARCH-FRONTEND] Checkpoint: Empty search term, clearing results');
            // Clear results if search is empty
            props.showTable(false);
            return;
        }
        
        if (term.trim().length < 3) {
            // console.log('[SEARCH-FRONTEND] Checkpoint: Search term too short (less than 3 characters), skipping search');
            return;
        }
        
        // console.log('[SEARCH-FRONTEND] Checkpoint: Search term valid (3+ characters), proceeding with search');
        // console.log('[SEARCH-FRONTEND] Checkpoint: Setting loading state to true');
        props.changeLoadingState(true);
        // console.log('[SEARCH-FRONTEND] Checkpoint: Showing table');
        props.showTable(true);
        
        const apiUrl = process.env.REACT_APP_SEARCH_JOBS || 'http://localhost:3000/search_jobs';
        // console.log('[SEARCH-FRONTEND] Checkpoint: API URL:', apiUrl);
        // console.log('[SEARCH-FRONTEND] Checkpoint: Making API request with payload:', { searchTerm: term });
        
        axios.post(apiUrl, { searchTerm: term })
            .then(response => {
                // console.log('[SEARCH-FRONTEND] Checkpoint: API response received');
                // console.log('[SEARCH-FRONTEND] Checkpoint: Response status:', response.status);
                // console.log('[SEARCH-FRONTEND] Checkpoint: Response data:', response.data);
                // console.log('[SEARCH-FRONTEND] Checkpoint: Number of results:', response.data ? response.data.length : 0);
                
                if (response.data && response.data.length > 0) {
                    // console.log('[SEARCH-FRONTEND] Checkpoint: Sample result:', {
                    //     title: response.data[0].title,
                    //     exam_name: response.data[0].exam_name,
                    //     content: response.data[0].content ? response.data[0].content.substring(0, 50) + '...' : 'No content'
                    // });
                }
                
                // console.log('[SEARCH-FRONTEND] Checkpoint: Calling updateFilteredJobs with results');
                props.updateFilteredJobs(response.data);
                // console.log('[SEARCH-FRONTEND] Checkpoint: Setting loading state to false');
                props.changeLoadingState(false);
            })
            .catch(error => {
                // console.log('[SEARCH-FRONTEND] Checkpoint: API request failed');
                // console.log('[SEARCH-FRONTEND] Checkpoint: Error details:', error);
                // console.log('[SEARCH-FRONTEND] Checkpoint: Error response:', error.response);
                // console.log('[SEARCH-FRONTEND] Checkpoint: Setting loading state to false');
                props.changeLoadingState(false);
            });
    };

    // COMMENTED OUT - Job Type Filter (may be reused later)
    /*
    const handleJobTypeChange = (event, value) => {
        const selectedIndex = event.target.selectedIndex;
        // console.log(value);
        // check if selectedIndex is valid and not the default value
        setFormData({ ...formData, "job_type": value });
        setJobTypeSelected(selectedIndex !== 0);
        setDegreeLoaded(!degreeLoaded);
    }
    */

    // COMMENTED OUT - Form submission handler (auto-update on degree selection)
    /*
    const handleSubmit = (event) => {
        event.preventDefault();
        // check if degreeSelected is true before submitting
        if (degreeSelected) {

            //show loader in the parent component
            props.changeLoadingState(true);
            // perform submit action
            // perform post request
            // console.log("got here");
            // console.log(formData)
            setShowProgress(true);
            axios.post(process.env.REACT_APP_GET_FILTERED_JOBS, { degree: formData.degree })
                .then(response => {
                    // console.log(response.data);
                    var filteredJobs = response.data;
                    filteredJobs.forEach(item => {
                        // console.log(item["title"]);
                    })

                    //update the jobs variable in the parent to update it in the table subsequently.
                    props.showTable(true);
                    props.updateFilteredJobs(filteredJobs);
                    // console.log(degreeDropdownList);
                    props.changeLoadingState(false);
                })
                .catch(error => {
                    // console.log(error);
                });

        } else {
            // display error message
            // console.log('Please select a degree value');
            setErrorMessage('Please select a degree');
        }
    }
    */

    // COMMENTED OUT - Job Type Filter (may be reused later)
    // const options = ["Government Job", 'Private Job']
    return <form action="/get_filtered_jobs" method="post" id="get_filtered_jobs_form"><div className="card">

        <div className="sub_div_center_aligned">
            {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}

            <p style={{ 
                color: '#10b981', 
                fontSize: '0.875rem', 
                marginBottom: '0.5rem',
                fontWeight: '500'
            }}>
                💡 Search jobs by typing keywords - results appear automatically after 1 second
            </p>

            <TextField
                fullWidth
                id="search-jobs"
                label="Search Jobs (by title or content)"
                variant="outlined"
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder="Type at least 3 characters to search..."
                sx={{ marginBottom: '1rem' }}
                onFocus={() => {/* console.log('[SEARCH-FRONTEND] Checkpoint: Search field focused') */}}
                onBlur={() => {/* console.log('[SEARCH-FRONTEND] Checkpoint: Search field blurred') */}}
            />

            <p style={{ 
                color: '#10b981', 
                fontSize: '0.875rem', 
                marginBottom: '0.5rem',
                fontWeight: '500'
            }}>
                💡 Select your degree - job results will appear automatically
            </p>

            {/* COMMENTED OUT - Job Type Autocomplete (may be reused later)
            <Autocomplete
                onChange={handleJobTypeChange}
                disablePortal
                id="combo-box-demo"
                options={options}
                renderInput={(params) => <TextField {...params} label="Select Job Type" />}
            /> <br />
            */}

            <Autocomplete
                onChange={handleDegreeChange}
                disablePortal
                id="degree-autocomplete"
                options={degreeDropdownList}
                freeSolo={false}
                disableClearable={false}
                sx={{}}
                className="degree"
                renderInput={(params) => <TextField {...params} label="Select Your Degree" />}
                renderOption={(props, option) => (
                    <li {...props} key={option}>
                        {option}
                    </li>
                )}
            />
            <br />
        </div>

        {/* COMMENTED OUT - Find Jobs Button (auto-update on degree selection)
        <div className="sub_div_center_aligned">
            <button 
                className="form_button" 
                type="submit" 
                disabled={!degreeSelected}
                style={{ 
                    opacity: degreeSelected ? 1 : 0.6,
                    cursor: degreeSelected ? 'pointer' : 'not-allowed'
                }}
            >
                Find Jobs
            </button>
        </div>
        */}
    </div>  </form>
}

export default ShowFilterCard;